export function parseApiError(error, overrides = {}) {
    const defaultMessage = 'Ocorreu um erro. Tente novamente.';
    let message = defaultMessage;
    let fieldErrors = null;
    const codes = [];
    let status;

    const resp = error?.response;
    if (resp) {
        status = resp.status;

        if (overrides[status]) {
            message = overrides[status];
        }

        const data = resp.data;

        if (data && typeof data === 'object' && data.errors && typeof data.errors === 'object') {
            fieldErrors = {};
            const messages = [];

            Object.entries(data.errors).forEach(([field, arr]) => {
                if (Array.isArray(arr)) {
                    fieldErrors[field] = arr.map((e) => {
                        const code = e.code || e.errorCode || '';
                        const msg = e.message || e.errorMessage || '';
                        if (code) codes.push(code);
                        if (msg) messages.push(msg);
                        return { code, message: msg };
                    });
                }
            });

            if (messages.length) {
                // junta com <br/> para exibição em HTML
                message = messages.map(m => escapeHtml(m)).join('<br/>');
            }
        } else if (Array.isArray(data)) {
            const first = data[0];
            if (first?.errorMessage) message = escapeHtml(first.errorMessage);
            if (first?.errorCode) codes.push(first.errorCode);
        } else if (typeof data === 'string') {
            message = escapeHtml(data);
        } else if (data?.detail) {
            message = escapeHtml(data.detail);
        } else if (data?.message) {
            message = escapeHtml(data.message);
        }
    } else if (error?.message) {
        message = escapeHtml(error.message);
    }

    return {
        message,
        status,
        raw: error,
        fieldErrors,
        codes: Array.from(new Set(codes)),
    };
}

// simples escapador para evitar injeção se passar direto em innerHTML
function escapeHtml(str) {
    return String(str)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
}
